import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  IconContainerLeft,
  IconContainerRight,
  ButtonContentRoot,
} from './ButtonContent.style';

const ButtonContent = ({ loading, IconLeft, IconRight, children, size }) => {
  if (loading) {
    return (
      <CircularProgress color="inherit" size={size === 'small' ? 15 : 20} />
    );
  }

  return (
    <ButtonContentRoot hasIcon={!!IconLeft || !!IconRight}>
      {IconLeft ? (
        <IconContainerLeft>
          <IconLeft />
        </IconContainerLeft>
      ) : null}

      <span>{children}</span>

      {IconRight ? (
        <IconContainerRight>
          <IconRight />
        </IconContainerRight>
      ) : null}
    </ButtonContentRoot>
  );
};

ButtonContent.defaultProps = {
  IconLeft: null,
  IconRight: null,
};

ButtonContent.propTypes = {
  loading: PropTypes.bool.isRequired,
  IconLeft: PropTypes.elementType,
  IconRight: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['small', 'medium']).isRequired,
};

export default React.memo(ButtonContent);
